import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=839c51fc&scoped=true&"
import script from "./FileInfo.vue?vue&type=script&lang=ts&"
export * from "./FileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FileInfo.vue?vue&type=style&index=0&id=839c51fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839c51fc",
  null
  
)

export default component.exports